import { useId } from 'react'
import type { InputHTMLAttributes } from 'react'
import styles from './ui.module.css'

type Props = InputHTMLAttributes<HTMLInputElement> & {
  label: string
  /** Hide the label visually but keep it for assistive technology. */
  hideLabel?: boolean
}

export function TextField({ label, hideLabel = false, id, ...rest }: Props) {
  const generated = useId()
  const inputId = id ?? generated
  return (
    <div className={styles.field}>
      <label className={hideLabel ? 'dp-sr-only' : styles.label} htmlFor={inputId}>
        {label}
      </label>
      <input id={inputId} className={styles.input} {...rest} />
    </div>
  )
}
